<button
  *ngIf="isArrowHide; else arrowButton"
  [ngClass]="ngClass"
  type="button"
  [disabled]="isButtonDisabled"
  [ngStyle]="{
    cursor: isButtonDisabled ? 'default' : 'pointer',
    backgroundColor: isFilled ? bgColor : 'transparent',
    borderColor: !isFilled && isFocusEnabled ? borderColor : '',
    color: textColor,
    width: buttonWidth,
    height: buttonHeight,
    padding: buttonPadding,
    fontSize: fontSize
  }"
  (click)="onHandleClick(); onClickButtonEvent($event)"
>
  {{ name }}
</button>

<ng-template #arrowButton>
  <button
    *ngIf="!isIconOnlyButton"
    [ngClass]="ngClass"
    type="button"
    [disabled]="isButtonDisabled"
    [ngStyle]="{
      cursor: isButtonDisabled ? 'default' : 'pointer',
      backgroundColor: isFilled ? bgColor : 'transparent',
      borderColor: !isFilled && isFocusEnabled ? borderColor : '',
      color: textColor,
      width: buttonWidth,
      height: buttonHeight,
      fontSize: fontSize
    }"
    (click)="onHandleClick(); onClickButtonEvent($event)"
  >
    <mat-icon
      *ngIf="isMatIcon"
      [ngClass]="ngIconClass"
      class="button-icon"
      [ngStyle]="{ color: iconColor }"
      >{{ icon }}</mat-icon
    >
    <i
      *ngIf="!isMatIcon"
      [class]="icon"
      [ngClass]="ngIconClass"
      class="button-icon"
      [ngStyle]="{ color: iconColor }"
    >
    </i>
    {{ name }}
  </button>

  <!-- icon only button without badge -->
  <button
    *ngIf="isIconOnlyButton && !isBadgeDisplay"
    class="icon-only-button"
    [ngClass]="ngClass"
    type="button"
    [disabled]="isButtonDisabled"
    [ngStyle]="{
      cursor: isButtonDisabled ? 'default' : 'pointer',
      backgroundColor: isFilled ? bgColor : 'transparent',
      borderColor: !isFilled && isFocusEnabled ? borderColor : '',
      color: textColor,
      padding: buttonPadding,
      width: buttonWidth,
      height: buttonHeight,
      fontSize: fontSize
    }"
    (click)="onHandleClick(); onClickButtonEvent($event)"
  >
    <mat-icon
      *ngIf="isMatIcon"
      class="button-icon"
      [ngClass]="ngIconClass"
      [ngStyle]="{ color: iconColor }"
      >{{ icon }}</mat-icon
    >
    <i
      *ngIf="!isMatIcon"
      [class]="icon"
      class="button-icon"
      [ngClass]="ngIconClass"
      [ngStyle]="{ color: iconColor }"
    >
    </i>
  </button>

  <!-- icon only button with badge -->
  <button
    *ngIf="isIconOnlyButton && isBadgeDisplay"
    class="icon-only-button"
    [ngClass]="ngClass"
    type="button"
    [disabled]="isButtonDisabled"
    [ngStyle]="{
      cursor: isButtonDisabled ? 'default' : 'pointer',
      backgroundColor: isFilled ? bgColor : 'transparent',
      borderColor: !isFilled && isFocusEnabled ? borderColor : '',
      color: textColor,
      padding: buttonPadding,
      width: buttonWidth,
      height: buttonHeight,
      fontSize: fontSize
    }"
    (click)="onHandleClick(); onClickButtonEvent($event)"
  >
    <mat-icon
      *ngIf="isMatIcon"
      class="button-icon"
      [ngClass]="ngIconClass"
      [ngStyle]="{ color: iconColor }"
      matBadge="{{ badgeValue }}"
      matBadgeColor="warn"
      >{{ icon }}</mat-icon
    >
    <i
      *ngIf="!isMatIcon"
      [class]="icon"
      class="button-icon"
      [ngClass]="ngIconClass"
      [ngStyle]="{ color: iconColor }"
    >
    </i>
  </button>
</ng-template>
